"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = Row;
exports.Cell = Cell;
exports.HeaderCell = HeaderCell;
exports.SubHeader = SubHeader;
exports.Header = Header;
exports.Body = Body;
exports.Table = Table;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../utils");
// Operator-density data table:
//   13px body · 14×18 padding · slate-50 header · 11px uppercase header label
//   in neutral-600 · neutral-50 row hover · neutral-50 dividers · neutral-100
//   bottom border on the head. Wrapped in a 24px-radius card with overflow
//   hidden so the rounded corners cover the table edges.
//
// All exports below are compositional — apps/business-web et al. compose
// `<Table>`, `<Body>`, `<Row>`, `<Cell>`, `<HeaderCell>`, `<Header>`, `<SubHeader>`
// directly. Do not change the public API; only the styling.
function Row(_a) {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return ((0, jsx_runtime_1.jsx)("tr", Object.assign({}, props, { className: (0, utils_1.cn)('transition-colors hover:bg-neutral-50', className), children: children })));
}
function Cell(_a) {
    var { children, className, paddingLeft } = _a, rest = __rest(_a, ["children", "className", "paddingLeft"]);
    return ((0, jsx_runtime_1.jsx)("td", Object.assign({ className: (0, utils_1.cn)('border-b border-neutral-50 px-[18px] py-3.5 text-[13px] text-neutral-800 align-middle', paddingLeft ? '' : 'px-[18px]', className) }, rest, { children: children })));
}
function HeaderCell(_a) {
    var { children, className, paddingLeft } = _a, rest = __rest(_a, ["children", "className", "paddingLeft"]);
    return ((0, jsx_runtime_1.jsx)("th", Object.assign({ className: (0, utils_1.cn)('border-b border-neutral-100 bg-neutral-50 px-[18px] py-3.5 text-left text-[11px] font-bold uppercase tracking-[0.06em] text-neutral-600 whitespace-nowrap', paddingLeft ? '' : 'px-[18px]', className) }, rest, { children: children })));
}
function SubHeader(_a) {
    var _b;
    var { children, paddingLeft } = _a, rest = __rest(_a, ["children", "paddingLeft"]);
    return ((0, jsx_runtime_1.jsx)(Row, { children: (0, jsx_runtime_1.jsx)("th", Object.assign({}, rest, { className: (0, utils_1.cn)('px-[18px] pt-4 text-left text-[11px] font-bold uppercase tracking-[0.06em] text-neutral-500', paddingLeft ? '' : 'px-[18px]', (_b = rest.className) !== null && _b !== void 0 ? _b : ''), children: children })) }));
}
function Header({ headers, children, paddingLeft, itemClassName = '', className }) {
    return ((0, jsx_runtime_1.jsx)("thead", { className: (0, utils_1.cn)('overflow-hidden', className), children: (0, jsx_runtime_1.jsx)("tr", { children: headers
                ? headers.map(header => ((0, jsx_runtime_1.jsxs)("th", { className: (0, utils_1.cn)('border-b border-neutral-100 bg-neutral-50 px-[18px] py-3.5 text-left whitespace-nowrap', paddingLeft ? '' : 'px-[18px]', itemClassName), scope: 'col', children: [(0, jsx_runtime_1.jsx)("span", { className: 'text-[11px] font-bold uppercase tracking-[0.06em] text-neutral-600', children: Array.isArray(header) ? header[0] : header }), Array.isArray(header) ? (0, jsx_runtime_1.jsx)("span", { className: 'block text-[11px] font-normal text-neutral-500', children: header[1] }) : null] }, Array.isArray(header) ? header[0] : header)))
                : children }) }));
}
function Body({ children, className = '' }) {
    return (0, jsx_runtime_1.jsx)("tbody", { className: (0, utils_1.cn)('[&>tr:last-child>td]:border-b-0', className), children: children });
}
function Table({ children, headers, headerClassName, allowOverflow }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: 'overflow-hidden rounded-2xl border border-neutral-100 bg-surface', children: (0, jsx_runtime_1.jsx)("div", { className: (0, utils_1.cn)(allowOverflow ? '' : 'overflow-x-auto'), children: (0, jsx_runtime_1.jsxs)("table", { className: 'min-w-full border-collapse text-[13px]', children: [headers ? (0, jsx_runtime_1.jsx)(Header, { className: headerClassName, headers: headers }) : null, children ? children : null] }) }) }));
}
